import React from 'react';
import './Header.css';

const Header = () =>{
    return <header className="main-header">
        
    </header>
}

export default Header;